module.exports = __webpack_public_path__ + "img/4.9560fa70.jpg";